class CommonUtils {
  static isWechatBrowser() {
    let ua = window.navigator.userAgent.toLocaleLowerCase();
    // eslint-disable-next-line
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    }
    return false;
  }

  static isIphoneBrowser() {
    let ua = window.navigator.userAgent.toLocaleLowerCase();
    // eslint-disable-next-line
    if (ua.match(/iphone/i) == 'iphone') {
      return true;
    }
    return false;
  }

  static doResolveSearchParam(location, name) {
    if(!location || !location.search) return ''
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = location.search.substr(1).match(reg);
    if (r !== null) {
      return unescape(r[2])
    }
    return '';
  }


  static resolveSearchParam(location, name) {
    let value = CommonUtils.doResolveSearchParam(location, name)
    if(CommonUtils.isEmpty(value)) {
      return CommonUtils.doResolveSearchParam(window.location, name)
    } else {
      return value
    }
  }

  static diffSeconds(dateTime1, dateTime2) {
    if (toString.call(dateTime1) !== '[object Date]') {
      dateTime1 = CommonUtils.stringToDate(dateTime1);
    }
    if (toString.call(dateTime2) !== '[object Date]') {
      dateTime2 = CommonUtils.stringToDate(dateTime2);
    }

    let millis1 = Date.parse(dateTime1),
        millis2 = Date.parse(dateTime2);
    return (millis1-millis2)/1000;
  }

  static shortenDateTime(dateStr) {
    if (!dateStr) {
      return dateStr;
    }

    let arr = dateStr.split(' ');
    if (arr.length !== 2) {
      return dateStr;
    }

    let dateArr = arr[0].split('-');
    let timeArr = arr[1].split(':');
    if (dateArr.length !== 3 || timeArr.length !== 3) {
      return dateStr;
    }

    return dateArr[1] + '-' + dateArr[2] + ' ' + timeArr[0] + ':' + timeArr[1]
  }

  static dateToString(date) {
    let dateArr = [date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()];
    for (let i = 0; i < dateArr.length; i++) {
      dateArr[i] = (dateArr[i] < 10) ? ("0" + dateArr[i].toString()) : dateArr[i];
    } 
    return dateArr.slice(0, 3).join('-') + ' ' + dateArr.slice(3).join(':');
  }

  static formatDate(date) {
    if(!date) return ''
    let dateArr = [date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()];
    for (let i = 0; i < dateArr.length; i++) {
      dateArr[i] = (dateArr[i] < 10) ? ("0" + dateArr[i].toString()) : dateArr[i];
    } 
    return dateArr.slice(0, 3).join('-');
  }

  static stringToDate(dateStr) {
    if (!dateStr) {
      return;
    }

    let arr = dateStr.split(' ');
    if (arr.length !== 2) {
      return;
    }

    let dateArr = arr[0].split('-');
    let timeArr = arr[1].split(':');
    if (dateArr.length !== 3 || timeArr.length !== 3) {
      return;
    }

    let date = new Date();
    // eslint-disable-next-line
    date.setFullYear(parseInt(dateArr[0]));
    // eslint-disable-next-line
    date.setMonth(parseInt(dateArr[1])-1);
    // eslint-disable-next-line
    date.setDate(parseInt(dateArr[2]));
    // eslint-disable-next-line
    date.setHours(parseInt(timeArr[0]));
    // eslint-disable-next-line
    date.setMinutes(parseInt(timeArr[1]));
    // eslint-disable-next-line
    date.setSeconds(parseInt(timeArr[2]));
    return date;
  }

  static generateQueryString(params) {
    let queryString = '';
    if(!params) {
      return queryString;
    }

    for (let name in params) {
      if (!name || !params[name]) {
        continue;
      }
      queryString += encodeURIComponent(name) + '=' + encodeURIComponent(params[name]) + '&'; 
    }
    return queryString;
  }

  static isNull(obj) {
    return obj === null || typeof obj === 'undefined' || obj === undefined;
  }

  static isEmpty(obj) {
    return CommonUtils.isNull(obj) || obj === '';
  }

  static isNotEmpty(obj) {
    return !CommonUtils.isEmpty(obj);
  }

  static addAmount(original, addition) {
    if (!original&&!addition) {
      return 0;
    }
    !original&&(original=0);
    !addition&&(addition=0);

    return Math.round(parseFloat((original + addition) * 100))/100
  }

  static substractAmount(original, subraction) {
    if (!original&&!subraction) {
      return 0;
    }
    !original&&(original=0);
    !subraction&&(subraction=0);

    return Math.round(parseFloat((original - subraction) * 100))/100
  }

  static getBrandWCPayRequest(params, callback) {
    window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
      appId: params.appId,    
      timeStamp: params.timeStamp,
      nonceStr: params.nonceStr,
      package: params.package,
      signType: params.signType,
      paySign: params.paySign
    }, function(res) {
      if(res.err_msg === "get_brand_wcpay_request:ok" ){
        callback&&callback()
      } 
    })
  }

  static invokeWechatPay(params, callback) {
    if(CommonUtils.isEmpty(params.paySign)) {
      callback&&callback()
      return
    }
    
    if(params.payChannel === 'QFL') {
      if(typeof window.WeixinJSBridge === "undefined") {
        if(document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', () => {CommonUtils.getBrandWCPayRequest(params, callback)}, false);
        } else if(document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', () => {CommonUtils.getBrandWCPayRequest(params, callback)}); 
          document.attachEvent('onWeixinJSBridgeReady', () => {CommonUtils.getBrandWCPayRequest(params, callback)});
        }
      } else {
        CommonUtils.getBrandWCPayRequest(params, callback)
      }
    } else {
      window.wx.chooseWXPay({
        appId: params.appId,
        timestamp: params.timeStamp,    
        nonceStr: params.nonceStr,  
        package: params.package,     
        signType: params.signType,
        paySign: params.paySign,
        success: function(res) {
          callback&&callback()
        }
      })
    }
  }

  static readableGameMinutes(gameMinutes) {
    if(!gameMinutes) {
        return '0'
    }

    // eslint-disable-next-line
    let hours = parseInt(gameMinutes / 60)
    let minutes = gameMinutes % 60
    if(!hours) {
        return `${minutes}分钟`
    }

    return `${hours}小时${minutes}分`
  }

  static generatePickerOptions(dict) {
    if(!dict) return []

    return Object.keys(dict).map(k => {
      return {value: k, label: dict[k]}
    })
  }

  static generatePickerOptionsFromList(listData, valueField='value', labelField='label') {
    if(!listData ||!listData.length) return []

    return listData.map(item => {
      return {value: item[valueField], label: item[labelField]}
    })
  }

  static resolveJoinDaysInfo(userJoinDays) {
    if(!userJoinDays || userJoinDays === '0') {
        return '当天'
    }
    
    try {
      // eslint-disable-next-line
      let days = parseInt(userJoinDays)
      if(!days || days <= 0) {
        return '当天'
      }

      let months = Math.floor(days/30)
      if(!months) {
        return `${userJoinDays}天前`
      } else {
        return `${months}个月前`
      }
    } catch(e) {
        return `${userJoinDays}天前`
    }
  }

  static resolveDictText(value, listData, valueField='code', textField='name') {
    if(!listData || !listData.length) {
      return value
    }

    for(let item of listData) {
      // eslint-disable-next-line
      if(item[valueField] == value) {
        return item[textField]
      }
    }
    return value
  }
}

export default CommonUtils;


// WEBPACK FOOTER //
// ./src/utils/CommonUtils.js